/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createTransactionTable = /* GraphQL */ `
  mutation CreateTransactionTable(
    $input: CreateTransactionTableInput!
    $condition: ModelTransactionTableConditionInput
  ) {
    createTransactionTable(input: $input, condition: $condition) {
      id
      SerialNumber
      CustomerName
      Barcode
      InsertTime
      Data
      Error
      createdAt
      updatedAt
    }
  }
`;
export const updateTransactionTable = /* GraphQL */ `
  mutation UpdateTransactionTable(
    $input: UpdateTransactionTableInput!
    $condition: ModelTransactionTableConditionInput
  ) {
    updateTransactionTable(input: $input, condition: $condition) {
      id
      SerialNumber
      CustomerName
      Barcode
      InsertTime
      Data
      Error
      createdAt
      updatedAt
    }
  }
`;
export const deleteTransactionTable = /* GraphQL */ `
  mutation DeleteTransactionTable(
    $input: DeleteTransactionTableInput!
    $condition: ModelTransactionTableConditionInput
  ) {
    deleteTransactionTable(input: $input, condition: $condition) {
      id
      SerialNumber
      CustomerName
      Barcode
      InsertTime
      Data
      Error
      createdAt
      updatedAt
    }
  }
`;
export const createTransactionSetupTable = /* GraphQL */ `
  mutation CreateTransactionSetupTable(
    $input: CreateTransactionSetupTableInput!
    $condition: ModelTransactionSetupTableConditionInput
  ) {
    createTransactionSetupTable(input: $input, condition: $condition) {
      id
      ExternalId
      WeightMap
      ImageMap
      createdAt
      updatedAt
    }
  }
`;
export const updateTransactionSetupTable = /* GraphQL */ `
  mutation UpdateTransactionSetupTable(
    $input: UpdateTransactionSetupTableInput!
    $condition: ModelTransactionSetupTableConditionInput
  ) {
    updateTransactionSetupTable(input: $input, condition: $condition) {
      id
      ExternalId
      WeightMap
      ImageMap
      createdAt
      updatedAt
    }
  }
`;
export const deleteTransactionSetupTable = /* GraphQL */ `
  mutation DeleteTransactionSetupTable(
    $input: DeleteTransactionSetupTableInput!
    $condition: ModelTransactionSetupTableConditionInput
  ) {
    deleteTransactionSetupTable(input: $input, condition: $condition) {
      id
      ExternalId
      WeightMap
      ImageMap
      createdAt
      updatedAt
    }
  }
`;
export const createConnectionConfigTable = /* GraphQL */ `
  mutation CreateConnectionConfigTable(
    $input: CreateConnectionConfigTableInput!
    $condition: ModelConnectionConfigTableConditionInput
  ) {
    createConnectionConfigTable(input: $input, condition: $condition) {
      id
      Name
      AccountId
      Token
      TokenSecret
      ExternalUser
      RfsmartRestlet
      AutomationRestlet
      ExpirationDate
      CustomerName
      EmailAddress
      createdAt
      updatedAt
    }
  }
`;
export const updateConnectionConfigTable = /* GraphQL */ `
  mutation UpdateConnectionConfigTable(
    $input: UpdateConnectionConfigTableInput!
    $condition: ModelConnectionConfigTableConditionInput
  ) {
    updateConnectionConfigTable(input: $input, condition: $condition) {
      id
      Name
      AccountId
      Token
      TokenSecret
      ExternalUser
      RfsmartRestlet
      AutomationRestlet
      ExpirationDate
      CustomerName
      EmailAddress
      createdAt
      updatedAt
    }
  }
`;
export const deleteConnectionConfigTable = /* GraphQL */ `
  mutation DeleteConnectionConfigTable(
    $input: DeleteConnectionConfigTableInput!
    $condition: ModelConnectionConfigTableConditionInput
  ) {
    deleteConnectionConfigTable(input: $input, condition: $condition) {
      id
      Name
      AccountId
      Token
      TokenSecret
      ExternalUser
      RfsmartRestlet
      AutomationRestlet
      ExpirationDate
      CustomerName
      EmailAddress
      createdAt
      updatedAt
    }
  }
`;
export const createQboidConfigTable = /* GraphQL */ `
  mutation CreateQboidConfigTable(
    $input: CreateQboidConfigTableInput!
    $condition: ModelQboidConfigTableConditionInput
  ) {
    createQboidConfigTable(input: $input, condition: $condition) {
      id
      SerialNumber
      CustomerName
      LengthField
      WidthField
      HeightField
      WeightField
      ImageField
      AltDimType
      AltLengthField
      AltWidthField
      AltHeightField
      AltWeightField
      AltImageField
      LengthUnit
      WeightUnit
      AlwaysRoundUpWeight
      AlwaysRoundUpLength
      WeightRoundingDigits
      LengthRoundingDigits
      InsertTime
      ConnectionName
      ExternalId
      AttributeMappings
      createdAt
      updatedAt
    }
  }
`;
export const updateQboidConfigTable = /* GraphQL */ `
  mutation UpdateQboidConfigTable(
    $input: UpdateQboidConfigTableInput!
    $condition: ModelQboidConfigTableConditionInput
  ) {
    updateQboidConfigTable(input: $input, condition: $condition) {
      id
      SerialNumber
      CustomerName
      LengthField
      WidthField
      HeightField
      WeightField
      ImageField
      AltDimType
      AltLengthField
      AltWidthField
      AltHeightField
      AltWeightField
      AltImageField
      LengthUnit
      WeightUnit
      AlwaysRoundUpWeight
      AlwaysRoundUpLength
      WeightRoundingDigits
      LengthRoundingDigits
      InsertTime
      ConnectionName
      ExternalId
      AttributeMappings
      createdAt
      updatedAt
    }
  }
`;
export const deleteQboidConfigTable = /* GraphQL */ `
  mutation DeleteQboidConfigTable(
    $input: DeleteQboidConfigTableInput!
    $condition: ModelQboidConfigTableConditionInput
  ) {
    deleteQboidConfigTable(input: $input, condition: $condition) {
      id
      SerialNumber
      CustomerName
      LengthField
      WidthField
      HeightField
      WeightField
      ImageField
      AltDimType
      AltLengthField
      AltWidthField
      AltHeightField
      AltWeightField
      AltImageField
      LengthUnit
      WeightUnit
      AlwaysRoundUpWeight
      AlwaysRoundUpLength
      WeightRoundingDigits
      LengthRoundingDigits
      InsertTime
      ConnectionName
      ExternalId
      AttributeMappings
      createdAt
      updatedAt
    }
  }
`;
